import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  Text,
  FormControl,
  FormLabel,
  Switch,
  useToast,
} from '@chakra-ui/react';

import { deleteSkuListingApi } from 'features/sku-management/sku-management.api';

const DeleteListingModal = ({ isOpen, onClose, skuMongoId, listing, onDeleted }) => {
  const dispatch = useDispatch();
  const toast = useToast();
  const [endOnMarketplace, setEndOnMarketplace] = useState(true);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    if (!skuMongoId || !listing?.listingId) return;
    setIsDeleting(true);
    const result = await dispatch(
      deleteSkuListingApi({
        skuMongoId,
        listingId: listing.listingId,
        endOnMarketplace,
      }),
    );
    setIsDeleting(false);

    if (deleteSkuListingApi.fulfilled.match(result)) {
      toast({
        title: 'Listing deleted',
        status: 'success',
        duration: 4000,
        isClosable: true,
      });
      onClose();
      onDeleted?.();
    } else {
      toast({
        title: 'Delete failed',
        description: result.payload?.message || 'Could not delete listing',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete listing</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text mb={2} noOfLines={2}>
            {listing?.title || 'Listing'}
          </Text>
          <Text fontSize="sm" color="gray.500" mb={4}>
            {listing?.storeName} · Item ID {listing?.externalPlatformId || '—'}
          </Text>
          <FormControl display="flex" alignItems="center">
            <FormLabel mb={0} flex={1}>
              End listing on marketplace
            </FormLabel>
            <Switch
              isChecked={endOnMarketplace}
              onChange={(e) => setEndOnMarketplace(e.target.checked)}
              colorScheme="red"
            />
          </FormControl>
        </ModalBody>
        <ModalFooter gap={3}>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button colorScheme="red" onClick={handleDelete} isLoading={isDeleting}>
            Delete listing
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteListingModal;
